import { render } from "./ClassMessage.vue?vue&type=template&id=2cfd4e8e"
import script from "./ClassMessage.vue?vue&type=script&lang=js"
export * from "./ClassMessage.vue?vue&type=script&lang=js"

import "./ClassMessage.vue?vue&type=style&index=0&id=2cfd4e8e&lang=css"

import exportComponent from "C:\\Users\\surface\\3D Objects\\Work\\schools\\inspire-school\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__